// import dd from "../images/BLlogo.png";

const Images = [
  {
    placeholder:"L#I=.iWBxZWB~UWDR*j]^#ofWWj?",
    img:require("../images/group/coach.jpg"),
  },
  {
    placeholder:"LpJ[S3RRRQoc%%WBozWC?IWBR%of",
    img: require("../images/group/areajpg.JPG"),
  },
  {
    placeholder:"L6Hfec9t}fM|dSo4Izsn.nV?E|Rk",
    img: require("../images/group/players.jpg"),
  },
  {
    placeholder:"LPGclbNGxlR+^mRjIYV@}gRjRRV@",
    img: require("../images/group/team.jpg"),
  },
 
];

export default Images;
